// extracted by mini-css-extract-plugin
module.exports = {"labels":"labels_labels__1wNNN","labelContainer":"labels_labelContainer__GImhp","label":"labels_label__2BOFH","labelText":"labels_labelText__8zGpk"};